'use strict';

import * as THREE from "three";
import Stats from "three/examples/jsm/libs/stats.module";

import {isDev, settingsData, threeJsVariables} from "../../settings";
import {PerspectiveCamera_init} from "./camera";
import {directionlight} from "./lights";
import {postProcessing} from "../post-processing/post-processing";
import { get_url_param, getUrlParam } from '../../functions';
import {getCurrentLangDirection} from "../language/langSwitcher";
import { PostFX } from '../post-processing/PostFX';

export const createThreeJsEnvironment = () => {
    const isMobileApple = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    const logarithmicDepthBuffer = config.threejs.renderer?.logarithmicDepthBuffer;
    const canvas = document.querySelector('#c');
    const width = window.innerWidth;
    const height = window.innerHeight;

    const scene = new THREE.Scene();
    const raycaster = new THREE.Raycaster();

    const renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true,
        logarithmicDepthBuffer,
        autoClear: true,
        stencil: false,
        //precision : 'lowp',
        //powerPreference: 'high-performance', // на некоторых десктоп устройствах вызывает перегрузку GPU, на остальных не дает никакого эффекта
    });

    const perspectiveCamera = PerspectiveCamera_init();

    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize( width, height );
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.autoUpdate = false;
    renderer.sortObjects = false;
    // renderer.shadowMap.type = THREE.VSMShadowMap;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.setClearColor( 0x000000, 1 );

    // setTimeout(() => {
    //     renderer.forceContextLoss();
    // }, 30000);
    // renderer.physicallyCorrectLights = true;

    const context = renderer.getContext();

    if (context) {
        context.canvas.addEventListener("webglcontextlost", function(event) {
            event.preventDefault();
            console.log('webglcontextlost');
            // animationID would have been set by your call to requestAnimationFrame
            cancelAnimationFrame(settingsData.renderAnim);
            window.location.reload();

        }, false);
    }

    // renderer.context.canvas.addEventListener("webglcontextrestored", function(event) {
    //     // Do something
    //     console.log('webglcontextrestored');
    //     window.location.reload();
    // }, false);

    threeJsVariables.scene = scene;
    threeJsVariables.renderer = renderer;
    threeJsVariables.raycaster = raycaster;
    threeJsVariables.scene.background = new THREE.Color(0x151515);

    threeJsVariables.perspectiveCamera = perspectiveCamera;

    directionlight();

    threeJsVariables.time = new THREE.Clock();

    settingsData.postProcessing.isActive && postProcessing(renderer,perspectiveCamera,canvas,scene)

    if (get_url_param('dev')){
        addRendererInfoGui();
    }
};

function addRendererInfoGui () {
    const {gui} = threeJsVariables;
    let loop;

    const params = {
        geometries: 0,
        textures: 0,
        triangles: 0,
        tiles: settingsData.totalTilesCount
    };

    const folder = gui.addFolder('Renderer info');

    folder.add( params, 'geometries');
    folder.add( params, 'textures');
    folder.add( params, 'triangles');
    folder.add(params,'tiles');

    const controllers = threeJsVariables.gui.__folders["Renderer info"].__controllers;

    function infoLoop () {
        controllers.forEach(control =>{
            control.object = {
                geometries: threeJsVariables.renderer.info.memory.geometries,
                textures: threeJsVariables.renderer.info.memory.textures,
                triangles: threeJsVariables.renderer.info.render.triangles,
                tiles: settingsData.totalTilesCount
            } ;
            control.updateDisplay();
        });

        loop = requestAnimationFrame(infoLoop);
    }

    infoLoop();
}

export function setStats() {
    if (!isDev) return;

    const stats = new Stats();
    stats.dom.style.top = '20px';
    stats.dom.style.left = '7%';

    threeJsVariables.stats = stats;

    document.body.insertAdjacentElement('afterbegin', stats.dom);
}




